import React, { Component } from "react";
import { connect } from "react-redux";
import { changeEditerModeAction, changeInPredictAction } from "../../redux/app/actions";
import {
  addDsAction,
  changeDsAction,
  changeNameAction,
  changeCatAction,
  changeGeoInfoAction,
  changeCoordSystemAction,
  changeColorAction,
  changeTabAction,
  isOkAction,
  isDrawAction,
  changeNewDataAction,
  changeFormDataAction,
  changeFileAction,
  changeXAttrAction,
  changeYAttrAction,
  changeDepThkRdoAction,
  changeZAttrAction,
  changeGeoAction,
  changeIDAction,
  changeGLChkAction,
  changeGLAction,
  changeWLChkAction,
  changeWLAction,
  changeHeaderNumAction,
  changeFieldNameChkAction,
  changeCsvDataAction,
  changeUserDataAction,
  changeNewDsAction,
  changeRegNumAction,
} from "../../redux/boring/actions";
import { changeRegModeEditerAction, changeBoringID2Action, changeBoringID1Action, updateWLTrAction, updatePompTrAction, changeMaxIDEditerAction } from "../../redux/editer/actions";

import { openSwAction } from "../../redux/ui/actions";
import Sw from "../common/Sw";
import Select from "../common/Select";
import List from "./List";
import Csv from "./Csv";
import User from "./User";

const mapStateToProps = state => {
  return {
    regMode: state.appReducer.regMode,
    geoDs: state.geoReducer.dataset,
    regNum: state.boringReducer.regNum,
    selRow: state.boringReducer.selRow,
    ds: state.boringReducer.dataset,
    catData: state.boringReducer.catData,
    name: state.boringReducer.name,
    cat: state.boringReducer.cat,
    geoInfo: state.boringReducer.geoInfo,
    coordSystem: state.boringReducer.coordSystem,
    color: state.boringReducer.color,
    tab: state.boringReducer.tab,
    isOk: state.boringReducer.isOk,
    isDraw: state.boringReducer.isDraw,
    file: state.boringReducer.file,
    XAttr: state.boringReducer.XAttr,
    YAttr: state.boringReducer.YAttr,
    depThkRdo: state.boringReducer.depThkRdo,
    ZAttr: state.boringReducer.ZAttr,
    geo: state.boringReducer.geo,
    ID: state.boringReducer.ID,
    GLChk: state.boringReducer.GLChk,
    GL: state.boringReducer.GL,
    WLChk: state.boringReducer.WLChk,
    WL: state.boringReducer.WL,
    headerNum: state.boringReducer.headerNum,
    fieldNameChk: state.boringReducer.fieldNameChk,
    csvData: state.boringReducer.csvData,
    newData: state.boringReducer.newData,
    formData: state.boringReducer.formData,
    userData: state.boringReducer.userData,
    wlTrData: state.editerReducer.editerWlMeaData,
    pompTrData: state.editerReducer.editerPompMeaData,
    maxID: state.editerReducer.maxID,
    initNum: state.boringReducer.initNum,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.ds = null;
    this.dsID = Object.keys(this.props.ds).length + 1;
    this.keys = ["ido_ID", "lon", "lat", "geo"];
    this.jsonArr = [];
    this.jsonLine = null;
    this.curID = null;
    this.bfID = null;
    this.geoInfoOpt = [];
    this.props.geoDs.forEach((el, index) => {
      this.geoInfoOpt.push({ val: index, text: el.name });
    });
    this.selRow = null;
    this.uniq_id = null;
    if (this.props.userData.length == undefined || this.props.userData.length == 0) {
      if (this.props.regMode === 1) {
        this.props.dispatch(changeUserDataAction(this.props.ds[this.props.selRow].data));
      }
    }

    this.changeName = this.changeName.bind(this);
    this.changeCat = this.changeCat.bind(this);
    this.changeCoordSystem = this.changeCoordSystem.bind(this);
    this.changeDepThkRdo = this.changeDepThkRdo.bind(this);
    this.changeColor = this.changeColor.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.doOK = this.doOK.bind(this);
    this.closeSw = this.closeSw.bind(this);
    this.openSw = this.openSw.bind(this);
    this.delPoint = this.delPoint.bind(this);

    if (this.props.regMode === 1) {
      //編集モードの場合
      this.ds = this.props.ds[this.props.selRow];
      this.dsID = this.ds.ID;
      this.props.dispatch(changeNameAction(this.ds.name));
      this.props.dispatch(changeCatAction(this.ds.cat));
      this.props.dispatch(changeGeoInfoAction(this.ds.geoInfo));
      this.props.dispatch(changeCoordSystemAction(this.ds.coordSystem));
      this.props.dispatch(changeColorAction(this.ds.color));

      if (this.props.initNum <= this.props.selRow) {
        //既存データセット以外
        this.props.dispatch(changeFileAction(this.ds.file));
        this.props.dispatch(changeXAttrAction(this.ds.XAttr));
        this.props.dispatch(changeYAttrAction(this.ds.YAttr));
        this.props.dispatch(changeDepThkRdoAction(this.ds.depThkRdo));
        this.props.dispatch(changeZAttrAction(this.ds.ZAttr));
        this.props.dispatch(changeGeoAction(this.ds.geo));
        //this.props.dispatch(changeIDAction(this.ds.pID));
        this.props.dispatch(changeGLChkAction(this.ds.GLChk));
        this.props.dispatch(changeGLAction(this.ds.GL));
        this.props.dispatch(changeWLChkAction(this.ds.WLChk));
        this.props.dispatch(changeWLAction(this.ds.WL));
        this.props.dispatch(changeHeaderNumAction(this.ds.headerNum));
        this.props.dispatch(changeFieldNameChkAction(this.ds.fieldNameChk));
        this.props.dispatch(changeCsvDataAction(this.ds.csvData));
        this.props.dispatch(changeNewDataAction(this.ds.newData));
        this.props.dispatch(changeFormDataAction(this.ds.formData));
        //his.props.dispatch(changeUserDataAction(this.ds.userData));
      }
    }
  }

  /*
   * 最大IDを取得
   * @since ando 2024-12-07
   */
  getMaxID() {
    if (this.props.userData.length != undefined) {
      let maxId = 0;
      this.props.userData.forEach(el => {
        let idArr = el.ido_ID.split("-");
        let id = Number(idArr[[idArr.length - 1]]);
        if (id > maxId) {
          maxId = id;
        }
      });
      this.props.dispatch(changeMaxIDEditerAction(maxId));
    } else {
      this.props.dispatch(changeMaxIDEditerAction(0));
    }
  }

  /*
   * 名称変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeName(e) {
    this.props.dispatch(changeNameAction(e.target.value));
  }

  /*
   * 分類変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeCat(e) {
    this.props.dispatch(changeCatAction(e.target.value));
  }

  /*
   * 座標系変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeCoordSystem(e) {
    this.props.dispatch(changeCoordSystemAction(e.target.value));
  }

  /*
   * 深度・層厚ラジオ変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-24
   */
  changeDepThkRdo(e) {
    this.props.dispatch(changeDepThkRdoAction(e.target.value));
  }

  /*
   * カラー変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeColor(e) {
    this.props.dispatch(changeColorAction(e.target.value));
  }

  /*
   * タブ変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeTab(e) {
    this.props.dispatch(changeTabAction(e.target.value));
  }

  /*
   * テーブルクリック
   * @since ando 2024-07-29
   */
  changeRow = e => {
    e.target.closest("tbody").childNodes.forEach(el => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");
    this.selRow = tr.id;
    console.log(`Row ${tr.id} clicked!`);
  };

  /*
   * CSVデータをマップ表示用フォーマットに成形
   * @since hara 2020-09-25
   */
  formCSV() {
    this.jsonArr = [];
    this.jsonLine = null;
    this.curID = null;
    this.bfID = null;
    const length = this.props.newData.length;

    if (length) {
      for (let i = 0; i < length; i++) {
        //空白行が出てきた場合終了
        if (this.props.newData[i] === "") break;

        //','ごとに配列化
        let arrD = String(this.props.newData[i]).split(",");
        this.curID = arrD[parseInt(this.props.ID)];

        //一行目スキップ
        if (i === 0) continue;
        for (let j = 0; j < this.keys.length; j++) {
          if (this.curID !== this.bfID) {
            //IDが前の行と異なる場合
            switch (j) {
              case 0: //ID
                this.jsonLine = new Object();
                this.jsonLine[this.keys[j]] = arrD[parseInt(this.props.ID)];
                break;
              case 1: //lon
                this.jsonLine[this.keys[j]] = parseFloat(arrD[parseInt(this.props.XAttr)]);
                break;
              case 2: //lat
                this.jsonLine[this.keys[j]] = parseFloat(arrD[parseInt(this.props.YAttr)]);
                break;
              case 3: //geo
                this.jsonLine[this.keys[j]] = [[parseFloat(arrD[j]), parseFloat(arrD[j + 1])]];
                this.jsonArr.push(this.jsonLine);
                this.bfID = arrD[parseInt(this.props.ID)];
                break;
            }
          } else {
            if (j === 3) {
              this.jsonLine.geo.push([parseFloat(arrD[parseInt(this.props.ZAttr)]), parseFloat(arrD[parseInt(this.props.geo)])]);
            }
          }
        }
      }

      this.props.dispatch(changeFormDataAction(this.jsonArr));
    }

    this.props.dispatch(isOkAction(true));
  }

  /*
   * ユーザーボーリングをサーバーに登録
   * @since ando 2024-12-09
   */
  uploadBoring() {
    if (this.props.userData.length == undefined || this.props.userData.length == 0) {
      alert("ボーリングデータを登録してください。");
    } else {
      this.waiting(true);
      const origin = window.location.origin;
      const search = window.location.search;
      if (this.props.regMode === 1) {
        //編集モードの場合
        this.uniq_id = this.ds.uniq_id;
      } else {
        this.uniq_id = Date.now().toString(36) + Math.random().toString(36).substring(2);
      }
      //選択したハイパーパラメータのIDをDBに登録

      fetch(`${origin}/api/userboringOK/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          boring: this.props.userData,
          name: this.uniq_id,
        }),
      })
        .then(res => res.json())
        .then(res => {
          this.waiting(false);
          this.props.dispatch(isOkAction(true));
          this.props.dispatch(changeRegNumAction(this.dsID));
        })

        .catch(err => {
          console.log(err);
          alert("サーバーエラー");
          this.waiting(false);
        });
    }
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    //プロパティー初期化
    this.props.dispatch(changeNameAction(""));
    this.props.dispatch(changeCatAction("0"));
    this.props.dispatch(changeGeoInfoAction("0"));
    this.props.dispatch(changeCoordSystemAction("0"));
    this.props.dispatch(changeColorAction("#ffffff"));
    this.props.dispatch(changeTabAction("csv"));

    this.props.dispatch(changeFileAction(""));
    this.props.dispatch(changeXAttrAction(0));
    this.props.dispatch(changeYAttrAction(0));
    this.props.dispatch(changeDepThkRdoAction("dep"));
    this.props.dispatch(changeZAttrAction(0));
    this.props.dispatch(changeGeoAction(0));
    //this.props.dispatch(changeIDAction(0));
    this.props.dispatch(changeGLChkAction(false));
    this.props.dispatch(changeGLAction(0));
    this.props.dispatch(changeWLChkAction(0));
    this.props.dispatch(changeWLAction(0));
    this.props.dispatch(changeHeaderNumAction(0));
    this.props.dispatch(changeFieldNameChkAction(true));

    this.props.dispatch(changeCsvDataAction([]));
    this.props.dispatch(changeNewDataAction([]));
    this.props.dispatch(changeFormDataAction([]));
    this.props.dispatch(changeUserDataAction([]));

    this.props.dispatch(changeEditerModeAction(0));

    this.props.dispatch(openSwAction("boring"));
  }
  waiting = stat => {
    this.props.dispatch(changeInPredictAction(stat));
  };
  /*
   * OKボタンクリック…①
   * @since hara 2020-09-24
   */
  doOK() {
    //this.formCSV();
    this.uploadBoring();
  }

  /*
   * サブウィンドウを開く
   * @param {Number} mode 0=新規/1=編集
   * @since ando 2024-12-03
   */
  openSw(mode) {
    if (mode === 1 && this.selRow === null) return; //編集で行未選択の場合
    if (mode === 1) {
      this.props.dispatch(changeRegModeEditerAction(1));
      this.props.dispatch(changeBoringID1Action(this.props.selRow));
      this.props.dispatch(changeBoringID2Action(this.selRow));

      this.props.dispatch(openSwAction("userBoring"));
    } else {
      this.getMaxID();
      this.props.dispatch(changeRegModeEditerAction(0));
      this.props.dispatch(openSwAction("userBoring"));
    }
  }

  componentDidUpdate(prevProps) {
    /*
     * データセット変更…②
     */
    if (this.props.isOk) {
      let action = addDsAction;
      let vis = true;
      let use = true;
      let zIndex = parseInt(this.dsID);
      let formData = this.props.formData;

      if (this.props.regMode === 1) {
        //編集モードの場合
        action = changeDsAction;
        vis = this.ds.vis;
        use = this.ds.use;
        zIndex = this.ds.zIndex;
        if (this.dsID <= this.props.initNum) {
          //既存データの場合
          formData = this.props.ds[this.props.selRow].data;
        }
      }
      this.props.dispatch(
        action({
          ID: this.dsID,
          name: this.props.name,
          cat: parseInt(this.props.cat),
          geoInfo: this.props.geoInfo,
          coordSystem: this.props.coordSystem,
          color: this.props.color,
          vis: vis,
          use: use,
          zIndex: zIndex,
          data: formData.concat(this.props.userData),
          file: this.props.file,
          XAttr: this.props.XAttr,
          YAttr: this.props.YAttr,
          depThkRdo: this.props.depThkRdo,
          ZAttr: this.props.ZAttr,
          geo: this.props.geo,
          pID: this.props.ID,
          GLChk: this.props.GLChk,
          GL: this.props.GL,
          WLChk: this.props.WLChk,
          WL: this.props.WL,
          headerNum: this.props.headerNum,
          fieldNameChk: this.props.fieldNameChk,
          csvData: this.props.csvData,
          newData: this.props.newData,
          formData: formData,
          userData: this.props.userData,
          uniq_id: this.uniq_id,
        })
      );

      this.props.dispatch(isOkAction(false));
      this.props.dispatch(isDrawAction(true));
    }

    /*
     * ボーリング描画…③
     */
    if (this.props.isDraw) {
      let ds;
      if (this.props.regMode === 0) {
        //新規の場合
        ds = this.props.ds.slice(-1)[0]; //最後のデータセットを取得
      } else {
        //修正の場合
        ds = this.props.ds[this.props.selRow];
      }
      window.delUserPointLay();
      window.createBoringLay(ds.data, ds.color, ds.ID, ds.vis, ds.zIndex);

      this.closeSw();
      this.props.dispatch(changeNewDsAction(this.props.ds));
      this.props.dispatch(isDrawAction(false));
    }
  }

  /*
   * 削除
   * @since ando 2024-12-06
   */
  delPoint() {
    const selUserData = this.props.userData;

    //`this.selRow` のインデックスに該当するデータを除外
    const updatedData = selUserData.filter((el, i) => i !== Number(this.selRow));

    //IDを修正する

    //更新したデータを `changeUserDataAction` に渡して反映
    this.props.dispatch(changeUserDataAction(updatedData));

    //水位データと揚水データが存在する場合は削除する。
    if (this.props.wlTrData[this.props.selRow] != undefined) {
      if (this.props.wlTrData[this.props.selRow][this.selRow] != undefined) {
        const selWLTrData = this.props.wlTrData[this.props.selRow][this.selRow];
        const updatedWLData = selWLTrData.filter((el, i) => i !== Number(this.selRow));
        this.props.dispatch(updateWLTrAction(updatedWLData));
      }
    }
    if (this.props.pompTrData[this.props.selRow] != undefined) {
      if (this.props.pompTrData[this.props.selRow][this.selRow] != undefined) {
        const selPompTrData = this.props.pompTrData[this.props.selRow][this.selRow];
        const updatedPompData = selPompTrData.filter((el, i) => i !== Number(this.selRow));
        this.props.dispatch(updatePompTrAction(updatedPompData));
      }
    }
    this.getMaxID();
  }

  /*
   * GM-WELL解析用ボーリング削除処理
   * @since ando 2026-02-10
   */
  //delPoint() {
  //ボーリングデータから井戸に関する
  //}
  render() {
    return (
      <Sw title="ボーリング" focusName="boringMain">
        <div className="Unit l-row">
          <label>ID：</label>
          <p>{this.dsID}</p>
          <label className="l-blank">名称：</label>
          <input className="textM" type="text" value={this.props.name} onChange={this.changeName} />
          {/*<label className='l-blank'>分類：</label>*
                    <select className='selectM' value={this.props.cat} onChange={this.changeCat}>
                        {this.props.catData.map((el, index) => (
                            <option value={index} key={index}>{el.ID + ' : ' + el.name}</option>
                        ))}
                    </select>
                        */}
          <div className="l-row l-mtS">
            <label className="l-blank">カラー：</label>
            <input className="color" type="color" value={this.props.color} onChange={this.changeColor} />
          </div>
        </div>

        <div className="l-row l-mtS">
          <Select label="地質情報" options={this.geoInfoOpt} value={this.props.geoInfo} class="selectM" blank={false} action={changeGeoInfoAction} />
          <label>座標系：</label>
          <select className={this.dsID <= this.props.initNum ? "selectM disabled" : "selectM"} value={this.props.coordSystem} onChange={this.changeCoordSystem}>
            <option value="0">緯度経度 (10進数)</option>
          </select>
        </div>

        <div className="l-row l-mtS">
          {/*
                    <label className='l-blank'>Z属性：</label>
                    <input id='boringMain_depRdo' className='radio' value='dep' name='boringMain_depThkRdo' type='radio' checked={this.props.depThkRdo === 'dep'} onChange={this.changeDepThkRdo} />
                    <label htmlFor='boringMain_depRdo' className={this.dsID <= this.props.regNum ? 'disabled' : ''}>深度</label>
                    <input id='boringMain_thkRdo' className='radio' value='thk' name='boringMain_depThkRdo' type='radio' checked={this.props.depThkRdo === 'thk'} onChange={this.changeDepThkRdo} />
                    <label htmlFor='boringMain_thkRdo' className={this.dsID <= this.props.regNum ? 'l-mlM disabled' : 'l-mlM'}>層厚</label>
                        */}
        </div>

        {/*
                    {this.props.tab === 'csv' ? <Csv /> : <User dsID={this.dsID} />}
                        */}
        <div>
          <div className="btnWrap">
            <button className="sBtn" onClick={() => this.openSw(0)}>
              新規
            </button>
            <button className="sBtn l-mlM" onClick={() => this.openSw(1)}>
              修正
            </button>
            <button className="sBtn l-mlM" onClick={this.delPoint}>
              削除
            </button>
          </div>
          <div className="BoringUserTWrap l-mtS" style={{ overflowY: "scroll" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th className="tsM">緯度</th>
                  <th className="tsM">経度</th>
                  <th>孔口標高</th>
                  <th>地下水位</th>
                </tr>
              </thead>
              <tbody ref={ref => (this.tbRef = ref)}>
                {Array.isArray(this.props.userData) &&
                  this.props.userData.map((el, index) => (
                    <tr id={index} key={index} onClick={e => this.changeRow(e)}>
                      <td>
                        <input className="textT" type="text" value={el.ido_ID} />
                      </td>
                      <td>
                        <input className="textT" type="text" value={el.lat} />
                      </td>
                      <td>
                        <input className="textT" type="text" value={el.lon} />
                      </td>
                      <td>
                        <input className="textT" type="text" value={el.GL} />
                      </td>
                      <td>
                        <input className="textT" type="text" value={el.WL} />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="l-right l-mtM">
          <button className="cBtn" onClick={this.doOK}>
            OK
          </button>
          <button className="cBtn l-mlS" onClick={this.closeSw}>
            キャンセル
          </button>
        </div>
      </Sw>
    );
  }
  /*★ここまで公開版で削除*/
}

export default connect(mapStateToProps)(Main);
